<template>
    <article class="LoginScreen">
        <img :src="getMediaPath(globalData?.data?.loginBackground?.src)" class="bg-img">
        <div class="container">
            <img class="logo" alt="Everhouse logo" src="@/assets/img/ui/logo.svg">
            <h1>{{ globalData?.data?.loginTitle }}</h1>

            <div class="start-container" v-if="!showLoginForm">
                <h2>{{ globalData?.data?.loginTagline }}</h2>
                <button class="begin-btn" @click="onBeginClick">Enter</button>
            </div>
            <div v-else class="password-form">
                <h3>Use your access code to sign in</h3>
                <input class="login-input" type="password" ref="loginKey" name="loginKey" id="loginKey"
                    placeholder="Enter access code" @click="focus" @keyup.enter="validate">
                <p class="error-text" v-show="showErrorText">Incorrect code, please try again</p>
                <button class="login-btn" type="submit" value="Login" @click="validate">Sign in</button>
            </div>
        </div>
    </article>
</template>

<script>
export default {
    data() {
        return {
            globalData: undefined,
            showErrorText: false,
            showLoginForm: false,
        };
    },
    mounted() {
        this.globalData = app.api.PageManager.getCustomComponentFromType('globalData');

    },
    methods: {
        getMediaPath(src) {
            return app.api.Utils.getMediaPath(src)
        },
        onBeginClick() {
            if (this.globalData.data.password === '' || app.api.LocalDataStore.get('isLoggedIn') === 'true-do-not-guess') {
                this.login();
                return;
            }
            this.showLoginForm = true
        },
        async validatePassword(message, keymatch) {
            // encode as UTF-8 
            const msgBuffer = new TextEncoder().encode(message); // hash the message 
            const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer); // convert ArrayBuffer to Array 
            const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert bytes to hex string 
            const hashHex = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('');
            return hashHex == keymatch;
        },
        validate() {
            const input = this.$refs.loginKey.value;
            const password = this.globalData.data.password;

            this.validatePassword(input, password).then((res) => {
                if (res === true) {
                    this.login();
                } else {
                    this.$refs.loginKey.focus();
                    this.showErrorText = true;
                }
            })
        },
        login() {
            app.api.LocalDataStore.set('isLoggedIn', 'true-do-not-guess');
            this.$store.commit('setLoggedIn', true);
        }
    },
}
</script>

<style lang="scss" scoped>
.LoginScreen {
    position: absolute;
    width: 100%;
    height: 100%;
    min-width: 2160px;
    transform: translateX(-50%);
    left: 50%;
    z-index: 1;

    display: flex;
    justify-content: center;

    overflow: hidden;
}

.bg-img {
    position: absolute;
    object-fit: cover;
    width: 101%;
    height: 101%;
    top: -3px;
    left: -3px;
    // filter: blur(10px);
}

.logo {
    width: 323px;
    margin-top: 354px;
}

.container {
    position: relative;
    height: 100%;
    width: 62%;
    z-index: 0;

    gap: 40px;

    // display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

h1 {
    margin-top: 26px;
    font-size: 140px;
    font-weight: 700;
    color: white;
    text-transform: uppercase;
    letter-spacing: -0.03em;
    font-family: 'Montserrat';
}

h2 {
    color: white;
    font-size: 36px;
    font-family: 'Montserrat';
    font-weight: 500;
}

h3 {
    font-size: 32px;
    font-weight: 400;
    line-height: 1.2;
    text-transform: uppercase;
    margin-bottom: 36px;
}

.start-container {
    height: 336px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.begin-btn {
    color: #231E55;
    font-family: 'Montserrat';
    font-size: 24px;
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 1.1;
    background-color: var(--yellow-white-50);
    padding: 10px 50px;

    border-radius: 200px;

    transition: transform .2s ease-in-out;

    &:hover {
        transform: scale(1.1);
    }
}

.password-form {
    background-color: white;
    width: 40%;
    padding: 50px 60px;
    border-radius: 4px;
    margin: auto;
}

.login-input {
    width: 100%;
    height: 60px;
    background-color: #FBFBFD;
    border: 1px solid #CCCCCC;
    border-radius: 4px;

    &::placeholder {
        color: #CCCCCC;
    }
}

.login-btn {
    margin-top: 40px;
    display: block;
    text-align: center;
    width: 100%;
    background-color: var(--main-color);
    color: white;

    font-size: 18px;
    font-weight: 500;
    height: 50px;

    &:hover {
        filter: brightness(1.2);
    }

    &:active {
        transform: scale(.98);
    }
}

.error-text {
    color: var(--error-color);
    font-size: 14px;
    text-transform: uppercase;
    position: absolute;
    font-family: 'Montserrat';
    // text-align: center;
    left: 50%;
    margin-top: 5px;
    transform: translateX(-50%);

}
</style>